import { isEmpty } from '@ember/utils';

import Transform from '@ember-data/serializer/transform';

import { uniqueId } from 'webapp/utils/common';

export default class ObjectTransform extends Transform {
	deserialize(serialized: number | null | undefined): number {
		return isEmpty(serialized) ? uniqueId() : Number(serialized);
	}

	serialize(deserialized: number | null | undefined): number {
		return isEmpty(deserialized) ? uniqueId() : Number(deserialized);
	}
}

declare module '@ember-data/serializer/transform' {
	interface TransformRegistry {
		uniqueid: number;
	}
}
